// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__256-r","wrapper_active":"wrapper_active__3O0ID","margin_right":"margin_right__3VGCX","label":"label__1J4KM","label_active":"label_active__3TK-_"};